import React, { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import PermissionGuard from '../components/PermissionGuard';

export default function SalesReports() {
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to sales page by default
  useEffect(() => {
    if (location.pathname === '/sales-reports') {
      navigate('/sales-reports/sales');
    }
  }, [location.pathname, navigate]);

  return (
    <PermissionGuard permission="salesReports.pageAccess">
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-2xl font-semibold text-gray-900">Sales Reports</h1>
          </div>
          <Outlet />
        </div>
      </div>
    </PermissionGuard>
  );
} 